module.exports = __webpack_public_path__ + "img/csain-logo.129cf579.jpg";